import { Capacitor } from "@capacitor/core";

// Browser development may use CRA /api proxy. Android/Capacitor must always
// call the production HTTPS API directly and must never resolve /api locally.
const configuredApiBase = String(process.env.REACT_APP_API_BASE || "").trim().replace(/\/$/, "");
export const API_BASE = Capacitor.isNativePlatform()
  ? "https://kgonline.in/api"
  : (configuredApiBase || "/api");
